import React from 'react'
import CustomModal from 'components/global/CustomModal'
import CustomModalFooter from 'components/global/CustomModalFooter'
import { teamStore } from 'state/team/team'
import TeamLeadForm from './ModalContent/TeamLeadForm'

interface ManageTeamLeadProps {
  teamId: string
  organizationId: string
  refetch: () => void
}

const ManageTeamLead: React.FC<ManageTeamLeadProps> = ({ teamId, organizationId, refetch }) => {
  const { teamLeadModalVisible, setTeamLeadModalVisible } = teamStore(store => ({
    teamLeadModalVisible: store.teamLeadModalVisible,
    setTeamLeadModalVisible: store.setTeamLeadModalVisible,
  }))

  return (
    <CustomModal
      openModal={teamLeadModalVisible}
      closeModal={setTeamLeadModalVisible}
      title="Add Team Lead"
      footer={
        <CustomModalFooter
          multibutton={false}
          btnAlignment="justify-end"
          btnText="Close"
          onSubmit={() => setTeamLeadModalVisible(false)}
        />
      }
    >
      <TeamLeadForm teamId={teamId} organizationId={organizationId} onSuccess={refetch} />
    </CustomModal>
  )
}

export default ManageTeamLead
